import { BadgeContext } from "@/providers/BadgeProvider";
import { useContext } from "react";

export function useBadge() {
  const context = useContext(BadgeContext);
  if (context === undefined) {
    throw new Error("useBadge must be used within a BadgeProvider");
  }
  return context;
}
